import {subscribe} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useSubscriptionStore = defineStore('subscriptionStore', {
  state: () => ({
    getSubscription: {},
    loading: false,
    error: null,
  }),
  actions: {
    async createSubscription(payload) {
      this.loading = true
      try {
        const response = await subscribe.postSubscription(payload)
        this.getSubscription = response.data
        toast.success(successHandler('CREATE_SUBSCRIPTION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },
  },
})
